import { EnumCountryRegions } from "../../enums/enumCountryRegions";
import EnumRecordTypes from "../../enums/enumRecordTypes";
import EnumStateProvinces from "../../enums/enumStateProvinces";
import {
  GET_CONTACT,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_ERROR,
  GET_CONTACT_INFORMATION,
  GET_CONTACT_INFORMATION_SUCCESS,
  GET_CONTACT_INFORMATION_ERROR,
  CREATE_CONTACT_INFORMATION,
  CREATE_CONTACT_INFORMATION_SUCCESS,
  CREATE_CONTACT_INFORMATION_ERROR,
  UPDATE_CONTACT_INFORMATION,
  UPDATE_CONTACT_INFORMATION_SUCCESS,
  UPDATE_CONTACT_INFORMATION_ERROR,
  TOGGLE_CREATE_CONTACT_INFORMATION_PANEL,
  TOGGLE_CREATE_CONTACT_INFORMATION_PANEL_SUCCESS,
  GET_PRIMARY_CONTACT_METHODS,
  GET_PRIMARY_CONTACT_METHODS_SUCCESS,
  GET_PRIMARY_CONTACT_METHODS_ERROR,
  GET_CONTACT_METHOD_TYPES,
  GET_CONTACT_METHOD_TYPES_SUCCESS,
  GET_CONTACT_METHOD_TYPES_ERROR,
  GET_CONTACT_TERMS,
  GET_CONTACT_TERMS_SUCCESS,
  GET_CONTACT_TERMS_ERROR,
  GET_CONTACT_TERMS_SUFFIX,
  GET_CONTACT_TERMS_SUFFIX_SUCCESS,
  GET_CONTACT_TERMS_SUFFIX_ERROR,
  GET_STATE_PROVINCES_FOR_SELECTED_COUNTRY,
  CREATE_USER_ACCOUNT,
  CREATE_USER_ACCOUNT_ERROR,
  CHANGE_USER_PASSWORD_ERROR,
  CHANGE_USER_PASSWORD,
  CREATE_USER_ACCOUNT_SUCCESS,
  CHANGE_USER_PASSWORD_SUCCESS,
  UPDATE_CONTACT_DETAILS_STATE,
  GET_CONTACT_USERNAME_EXIST,
  GET_CONTACT_USERNAME_EXIST_SUCCESS,
  GET_CONTACT_USERNAME_EXIST_ERROR,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_CONTACT,
  UPDATE_CONTACT_SUCCESS,
  UPDATE_CONTACT_ERROR
} from "../actions";

const INIT_STATE = {
  contactId: null,
  vocabularyName: null,
  contact: null,
  contactMethodTypes: null,
  contactTerms: null,
  contactTermsSuffix: null,
  contactMethods: null,
  primaryContactMethods: null,
  contactActivities: null,
  addEditContactInfo: null,
  isAddEditPanelOpened: false,
  isAdd: true,
  stateProvinces: null,
  selectedCountryId: 124,
  isUserAccountPanelShown: false,
  isChangePasswordPanelShown: false,
  contactDetailsError: "",
  successMessage: "",
  changePasswordSuccessMessage: "",
  userName: "",
  isValidUserName: null,
  createAllowed: null,
  updateUserError: "",
  deleteUserError: "",
  updateUserSuccessMessage: "",
  deleteUserSuccessMessage: "",
  isUpdateUserPanelShown: false,
  verbType : 2,
  isPageRefresh : true
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CONTACT_USERNAME_EXIST:
      return { ...state, loading: true, userName: action.payload.userName };
    case GET_CONTACT_USERNAME_EXIST_SUCCESS:
      return {
        ...state, loading: false,
        isValidUserName: action.payload.isValidUserName,
        createAllowed: action.payload.createAllowed,
        contactDetailsError: action.payload.isValidUserName == true ? action.payload.createAllowed == false ? "Username already exist" : "Username already exist" : ""
      };
    case GET_CONTACT_TERMS:
      return {
        ...state,
        loading: true,
        vocabularyName: action.payload.vocabularyName,
      };
    case GET_CONTACT_TERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contactTerms: action.payload.contactTerms,
      };
    case GET_CONTACT_TERMS_SUFFIX:
      return {
        ...state,
        loading: true,
        vocabularyName: action.payload.vocabularyName,
      };
    case GET_CONTACT_TERMS_SUFFIX_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contactTermsSuffix: action.payload.contactTermsSuffix,
      };
    case GET_CONTACT_METHOD_TYPES:
      return { ...state, loading: true };
    case GET_CONTACT_METHOD_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contactMethodTypes: action.payload.contactMethodTypes,
      };
    case GET_CONTACT:
    case GET_PRIMARY_CONTACT_METHODS:
      return {
        ...state,
        loading: true,
        contactDetailsError: "",
        contactId: action.payload.contactId,
        verbType : action.payload.verbType
      };
    case GET_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contact: action.payload.contact,
        contactTypes: action.payload.contactTypes,
        contactActivities: action.payload.contactActivities,
      };
    case GET_PRIMARY_CONTACT_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        primaryContactMethods: action.payload.primaryContactMethods,
      };
    case GET_CONTACT_INFORMATION:
      return {
        ...state,
        loading: true,
        contactDetailsError: "",
        contactId: action.payload.contactId,
      };
    case TOGGLE_CREATE_CONTACT_INFORMATION_PANEL:
      const contactMethods = [];
      const phoneNumber = {
        contactMethodId: "0",
        contactMethodGuid: null,
        recordType: "3215",
        recordState: "1",
        contactId: state.contactId,
        value: "",
        primary: false,
        onHold: false,
        countryRegion: "1",
        isUpdateRequired: true,
      };
      const faxNumber = {
        contactMethodId: "0",
        contactMethodGuid: null,
        recordType: "3210",
        recordState: "1",
        contactId: state.contactId,
        value: "",
        primary: false,
        onHold: false,
        isUpdateRequired: true,
      };
      const emailAddress = {
        contactMethodId: "0",
        contactMethodGuid: null,
        recordType: "3205",
        recordState: "1",
        contactId: state.contactId,
        value: "",
        primary: false,
        onHold: false,
        isUpdateRequired: true,
      };
      const website = {
        contactMethodId: "0",
        contactMethodGuid: null,
        recordType: "3220",
        recordState: "1",
        contactId: state.contactId,
        value: "",
        primary: false,
        onHold: false,
        isUpdateRequired: true,
      };
      const address = {
        contactMethodId: "0",
        contactMethodGuid: null,
        recordType: "3100",
        recordState: "1",
        contactId: state.contactId,
        value: "",
        primary: false,
        onHold: false,
        isUpdateRequired: true,
        address: {
          trashed: false,
          addressLine1: "",
          addressLine2: "",
          city: "",
          stateProvince: null,
          customStateProvince: "",
          postalZipCode: "",
          countryRegion: "124",
          version: "1",
          organization : null,
          organizationContactId : null
        },
      };
      contactMethods[EnumRecordTypes.Address] =
        action.payload.selectedContactMethods &&
          action.payload.selectedContactMethods[EnumRecordTypes.Address]
          ? action.payload.selectedContactMethods[EnumRecordTypes.Address]
          : address;
      contactMethods[EnumRecordTypes.PhoneNumber] =
        action.payload.selectedContactMethods &&
          action.payload.selectedContactMethods[EnumRecordTypes.PhoneNumber]
          ? action.payload.selectedContactMethods[EnumRecordTypes.PhoneNumber]
          : phoneNumber;
      contactMethods[EnumRecordTypes.FaxNumber] =
        action.payload.selectedContactMethods &&
          action.payload.selectedContactMethods[EnumRecordTypes.FaxNumber]
          ? action.payload.selectedContactMethods[EnumRecordTypes.FaxNumber]
          : faxNumber;
      contactMethods[EnumRecordTypes.EmailAddress] =
        action.payload.selectedContactMethods &&
          action.payload.selectedContactMethods[EnumRecordTypes.EmailAddress]
          ? action.payload.selectedContactMethods[EnumRecordTypes.EmailAddress]
          : emailAddress;
      contactMethods[EnumRecordTypes.Website] =
        action.payload.selectedContactMethods &&
          action.payload.selectedContactMethods[EnumRecordTypes.Website]
          ? action.payload.selectedContactMethods[EnumRecordTypes.Website]
          : website;
      const selectedCountry = contactMethods[EnumRecordTypes.Address].address
        .countryRegion
        ? contactMethods[EnumRecordTypes.Address].address.countryRegion
        : EnumCountryRegions.Canada;
      const stateProvincesFiltered = EnumStateProvinces.filter(
        (sp) => sp.CountryRegionId == selectedCountry
      );

      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        isAddEditPanelOpened: !state.isAddEditPanelOpened,
        isAdd: action.payload.isAdd,
        selectedTermId: action.payload.selectedTermId,
        addEditContactInfo: contactMethods,
        selectedCountryId: selectedCountry,
        stateProvinces: stateProvincesFiltered,
      };
    case TOGGLE_CREATE_CONTACT_INFORMATION_PANEL_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        addEditContactInfo: action.payload.addEditContactInfo,
      };
    case CREATE_CONTACT_INFORMATION:
      return {
        ...state,
        loading: true,
        contactDetailsError: "",
        contactMethods: action.payload.contactMethods,
        contactId: action.payload.contactId,
        isPageRefresh : action.payload.isPageRefresh
      };
    case UPDATE_CONTACT_INFORMATION:
      return {
        ...state,
        loading: true,
        contactDetailsError: "",
        contactMethods: action.payload.contactMethods,
      };
    case GET_CONTACT_INFORMATION_SUCCESS:
          return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contactMethods: action.payload.contactMethods,
        primaryContactMethods: action.payload.primaryContactMethods,
      };
    case CREATE_CONTACT_INFORMATION_SUCCESS:
          return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contactMethods: action.payload.contactMethods,
        primaryContactMethods: action.payload.primaryContactMethods,
        isAddEditPanelOpened: false,
      };
    case UPDATE_CONTACT_INFORMATION_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contactMethods: action.payload.contactMethods,
        primaryContactMethods: action.payload.primaryContactMethods,
        isAddEditPanelOpened: false,
      };
    case CREATE_USER_ACCOUNT:
    case CHANGE_USER_PASSWORD:
      return { ...state, loading: true, contactDetailsError: "" };
    case UPDATE_USER:
      return { ...state, loading: true, updateUserError: "" };
    case DELETE_USER:
      return { ...state, loading: true, deleteUserError: "" };
    case CHANGE_USER_PASSWORD_SUCCESS:
      return { ...state, loading: true, contactDetailsError: "", changePasswordSuccessMessage: action.payload.successMessage, isChangePasswordPanelShown: false };
    case CREATE_USER_ACCOUNT_SUCCESS:
      const contact = { ...state.contact, userName: action.payload.userName, userAccountType: action.payload.userAccountType };
      return { ...state, loading: true, contactDetailsError: "", contact, successMessage: action.payload.successMessage, isUserAccountPanelShown: true };
    case UPDATE_USER_SUCCESS:
      return { ...state, loading: true, updateUserError: "", updateUserSuccessMessage: action.payload.successMessage, isUpdateUserPanelShown: false };
    case DELETE_USER_SUCCESS:
      return { ...state, loading: true, deleteUserError: "", deleteUserSuccessMessage: action.payload.successMessage };
    case GET_CONTACT_ERROR:
    case GET_CONTACT_USERNAME_EXIST_ERROR:
    case CREATE_CONTACT_INFORMATION_ERROR:
    case UPDATE_CONTACT_INFORMATION_ERROR:
    case GET_PRIMARY_CONTACT_METHODS_ERROR:
    case GET_CONTACT_INFORMATION_ERROR:
    case GET_CONTACT_METHOD_TYPES_ERROR:
    case GET_CONTACT_TERMS_SUFFIX_ERROR:
    case GET_CONTACT_TERMS_ERROR:
    case CREATE_USER_ACCOUNT_ERROR:
    case CHANGE_USER_PASSWORD_ERROR:
      return { ...state, loading: false, contactDetailsError: action.payload ? action.payload.message : "" };
    case UPDATE_USER_ERROR:
      return { ...state, loading: false, updateUserError: action.payload ? action.payload.message : "" };
    case DELETE_USER_ERROR:
      return { ...state, loading: false, deleteUserError: action.payload ? action.payload.message : "" };
    case GET_STATE_PROVINCES_FOR_SELECTED_COUNTRY:
      const stateProvinces = EnumStateProvinces.filter(
        (sp) => sp.CountryRegionId == action.payload.selectedCountryId
      );
      return {
        ...state,
        loading: false,
        selectedCountryId: action.payload.selectedCountryId,
        stateProvinces,
      };
    case UPDATE_CONTACT_DETAILS_STATE:
      return { ...state, ...action.payload.updatedValues };
    case UPDATE_CONTACT:
      return {
        ...state,
        loading: true,
        contactDetailsError: "",
        contact: action.payload.contact,
      };
    case UPDATE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contactDetailsError: "",
        contact: action.payload.contact,
      };  
    case UPDATE_CONTACT_ERROR:
      return { ...state, loading: false, updateUserError: action.payload ? action.payload.message : "" };      
    default:
      return { ...state };
  }
};
